"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkBuilderMessageResultSchema = void 0;
const zod_1 = require("zod");
const MessageResult_1 = require("../../MessageResult");
exports.NetworkBuilderMessageResultSchema = (0, MessageResult_1.AggregateMessageResultSchema)(zod_1.default.literal('network-builder-result'), MessageResult_1.MessageResultSchemaDefault);
//# sourceMappingURL=NetworkBuilderMessageResult.js.map